import './vendor';
import Swiper from '../../node_modules/swiper/js/swiper.js';
import {fancybox} from '@fancyapps/fancybox';

$('[data-fancybox]').fancybox({
	touch: false,
});

$('.slider').each((i, e) => {
	let $e = $(e);

	let slider = new Swiper($e.find('.swiper-container'), {
		loop: true,
		autoHeight: true,
		navigation: {
			prevEl: $e.find('.slider__prev')[0],
			nextEl: $e.find('.slider__next')[0],
		},
		pagination: {
			el: $e.find('.slider__pager')[0],
			clickable: true,
		},
	});
	$(window).on('load', () => {
		slider.update();
	})
});

$('.arrow button').on('click', (e) => {
	let $target = $($(e.currentTarget).data('target'));

	if ($target.length) {
		e.preventDefault();
		$('html, body').animate({
			scrollTop: $target.offset().top,
		}, 400);
	}
});
